@if (!listView()) {
    <a class="card-item" routerLink="/{{AppRoutes.Videos}}/{{video().slug}}/">
        <div class="card-item-header">
            @if (video().status === PublishedStatus.Private) {
                <div class="private-badge">
                    <fa-icon [icon]="faLock" />
                    Private
                </div>
            }

            @if (video().status === PublishedStatus.Draft) {
                <div class="private-badge">
                    <fa-icon [icon]="faPencilAlt" />
                    Draft
                </div>
            }

            <img [src]="part()?.thumbnail" alt="video-img"
                 [attr.loading]="priorityImageLoading() ? 'eager' : 'lazy'"
                 [attr.fetchpriority]="priorityImageLoading() ? 'high' : 'low'"
                 decoding="async"
            />

            @if (part()?.duration; as duration) {
                <div class="badge">{{ duration | secondsToTimestamp }}</div>
            }
        </div>
        <div class="card-item-body">
            <h3>{{ customLectureTitle }}</h3>
            <div class="authors">
                @for (author of video().authors; track author.id; let last = $last) {
                    <h4 class="author">{{ author.name + (last ? '' : ',') }}</h4>
                }
            </div>
            <div class="info">
                <p class="date-views">
                    <span class="date-group">
                        <span class="icon-wrapper">
                            <img src="/assets/icons/calendar.svg" alt="calendar icon" />
                        </span>
                        {{ video().date | toDate }}
                    </span>
                    <span class="views-group">
                        <span class="icon-wrapper">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                        </span>
                        {{ video().total_views }} views
                    </span>
                </p>
            </div>
        </div>
        <!-- @if (video().type || canDelete()) {
            <div class="card-item-footer" [class.delete]="canDelete()">
                <app-badge [text]="video().type | typeToString" /> 
                @if (canDelete()) {
                    <fa-icon class="delete-icon" [icon]="faTrash" />
                }
            </div>
        } -->
        @if (progress) {
            <div class="progress-bar">
                <p>{{ minutesLeft ? minutesLeft + " min left" : " " }}</p>
                <p-progressBar [style]="{ height: '4px'}" color="#FF2E59" [value]="progress" [showValue]="false" />
            </div>
        }
    </a>
} @else {
    <div [ngClass]="(isPlaylist() || isBookmark()) ? 'list-view-playlist' : 'video-list-view'" class="list-view">
        @if (isBookmark()) {
            <fa-icon
                    class="icon"
                    mwlConfirmationPopover
                    popoverTitle="Delete confirmation"
                    popoverMessage="Are you sure you want to remove the lecture from bookmarks?"
                    placement="right"
                    (confirm)="removeFromBookmarksOrPlaylist()"
                    [icon]="faBookmarkSolid"
            />
        }
        @if (isPlaylist()) {
            <fa-icon
                    class="icon"
                    mwlConfirmationPopover
                    popoverTitle="Delete confirmation"
                    popoverMessage="Are you sure you want to remove the lecture from playlist?"
                    placement="right"
                    (confirm)="removeFromBookmarksOrPlaylist()"
                    [icon]="faTrash"
            />
        }
        <a routerLink="/{{AppRoutes.Videos}}/{{video().slug}}">
            <img [src]="part()?.thumbnail" [alt]="video().title  + 'image'"
                 [attr.loading]="priorityImageLoading() ? 'eager': 'lazy'" />
        </a>
        <a class="right" routerLink="/{{AppRoutes.Videos}}/{{video().slug}}">
            <div class="info">
                <h3 class="title">{{ video().title }}</h3>

                @if (video().authors.length) {
                    <div class="authors">
                        @for (author of video().authors; track author; let isLast = $last) {
                            <h4 class="author">
                                {{ author.name }}@if (!isLast) {
                                <span>,&nbsp;</span>
                            }
                            </h4>
                        }
                    </div>
                }
            </div>

            <div class="numbers">
                <p>{{ video().date | toDate }}</p>
                <p>{{ video().total_views }} views</p>

                @if ((isPlaylist() || isBookmark()) && video().type; as type) {
                    <app-badge [text]="type | typeToString" />
                }
            </div>
        </a>
    </div>
}
